import { FleekError } from './FleekError';

type UserSecretKeyNotFoundErrorOptions = Record<string, never>;

export class UserSecretKeyNotFoundError extends FleekError<UserSecretKeyNotFoundErrorOptions> {
  public name = 'UserSecretKeyNotFoundError';

  toString = () => 'A secret key for this user not found.';
}
